import { jsx as _jsx } from "react/jsx-runtime";
import { useObtainAuthToken } from './use-obtain-auth-token';
import { MainContext } from './main-context';
export function MainContextProvider(_a) {
    var children = _a.children;
    var _b = useObtainAuthToken(), status = _b.status, token = _b.token, hash = _b.hash;
    return (_jsx(MainContext.Provider, { value: {
            hash: hash,
            status: status,
            token: token,
        }, children: children }));
}
